import React from 'react'
import { InputPutAway } from '../InputPutAway/InputPutAway'

export const SearchPutAway = () => {
  return <InputPutAway />
}
